import { Client } from "./_clientService";

const executeRequest = async (options: any) => {
    try {
        const resp = await new Client(options)[options.method]();
        return resp;
    } catch (error) {
        throw error;
    }
};

export async function recalculateTeamRatings(params?: any) {
    return executeRequest({
        path: "/misc/reCalcTeamRatings",
        method: "post",
        payload: params,
    });
}

export async function allReCalculatedRatings() {
    return executeRequest({
        path: "/misc/allTeamRatingsRecalculations",
        method: "get",
    });
}

export async function stopTeamRatingsReCalculation(params: any) {
    return executeRequest({
        path: "/misc/stopTeamRatingsReCalculation",
        method: "post",
        payload: params,
    });
}